module.exports = __webpack_public_path__ + "img/reduction_top.66031669.png";